module.exports = __webpack_public_path__ + "img/c06_unittechpharmacology_Normal_ua.94a1e6b8.webp";